import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-pruefbericht-xml-template';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungPruefberichtXmlTemplateEffects {

    VeranstaltungPruefberichtXmlTemplate$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_PRUEFBERICHT_XML_TEMPLATE),
        mergeMap((x: ac.GetVeranstaltungPruefberichtXmlTemplateAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungPruefberichtXmlTemplate().pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungPruefberichtXmlTemplateErfolgreichAction(optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungPruefberichtXmlTemplateFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenTemplatesService);
        }
        return this.service;
    }
}
